export enum Symptoms {
  Confirmed = 'confirmed',
  Cough = 'cough',
  DifficultyBreathing = 'difficultyBreathing',
  Fever = 'fever',
  MusclePain = 'musclePain',
  NewLossOfTasteOrSmell = 'newLossOfTasteOrSmell',
  Quarantine = 'quarantine',
  SoreThroat = 'soreThroat',
}
